import injectIntl from "../../../../common/helpers/injectIntl";
import loadable from "./lazy";

export default injectIntl(loadable);
